import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Capabilities } from './components/Capabilities';
import { AttackSurfaces } from './components/AttackSurfaces';
import { Compliance } from './components/Compliance';
import { DemoCta } from './components/DemoCta';
import { Footer } from './components/Footer';
interface AppProps {
  /** 'light' is white + purple, 'dark' is black + purple. */
  theme?: 'light' | 'dark';
}
export function App({
  theme = 'light'
}: AppProps) {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle('theme-dark', theme === 'dark');
    return () => root.classList.remove('theme-dark');
  }, [theme]);
  return <div className={`min-h-screen w-full bg-canvas font-sans text-body ${theme === 'dark' ? 'theme-dark' : ''}`} data-id="element-0" data-mp="2wj8ehrfz0s5r">
      <Nav data-id="element-1" data-mp="28s2z1ddy01vz" />
      <main data-id="element-2" data-mp="23vkw8j26adma">
        <Hero data-id="element-3" data-mp="23vuoyeelqyvo" />
        <Capabilities data-id="element-4" data-mp="23u9ueosaffxt" />
        <AttackSurfaces data-id="element-5" data-mp="23ut97wmn5o7m" />
        <Compliance data-id="element-6" data-mp="23ti7018ugoim" />
        <DemoCta data-id="element-7" data-mp="3ik7k0rkruvvx" />
      </main>
      <Footer data-id="element-8" data-mp="3ij652c0mxp8x" />
    </div>;
}